<template>
  <div v-if="data.showButtonModal" class="modal-container">
    <div class="dimmed">
      <div class="modal">
        <div class="title">{{ title }}</div>
        <ul>
          <li
            v-for="(button, index) in data.buttons"
            :key="index"
            class="button-wrap"
          >
            <div @click="clickMoveTo(button.type)" class="item">
              {{ button.name }}
            </div>
            <!-- <router-link :to="{ name: button.path }">{{
              button.name
            }}</router-link> -->
          </li>
        </ul>
        <div @click="data.showButtonModal = false" class="close-button">
          {{ "닫기" }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    data: {
      buttons: String,
      showButtonModal: Boolean,
      closeButtonModal: Boolean,
    },
  },
  methods: {
    clickMoveTo(type) {
      this.$emit("move-to", type);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/color_palette.scss";

.modal-container {
  .dimmed {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 10;
    .modal {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 80%;
      max-width: 340px;
      border-radius: 16px;
      background-color: $BlueGray100;
      .title {
        padding: 20px 0;
        text-align: center;
        color: $BlueGray100;
        font-size: 14px;
        border-radius: 16px 16px 0 0;
        background-color: $Red500;
      }
      .button-wrap {
        padding: 0 16px;
        .item {
          border-bottom: 1px solid $BlueGray600;
          width: 100%;
          padding: 20px 0;
          text-align: center;
          font-size: 14px;
        }
        &:last-of-type {
          .item {
            border-bottom: none;
          }
        }
      }
      .close-button {
        width: 100%;
        padding: 20px 0;
        text-align: center;
        font-size: 14px;
        border-top: 1px solid $BlueGray600;
      }
    }
  }
}
</style>
